// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "foxit-UIExtension-full" + "." + "9e81b68050a78692" + ".js";
};